import Home from './views/Home.vue'
import CreatePalletPattern from './views/palletPattern/create.vue'
import ViewPalletPatterns from './views/palletPattern/view.vue'
import Details from './views/palletPattern/details.vue'
import EditPalletPattern from './views/palletPattern/edit.vue'
import Settings from './views/SettingsView.vue'
import MachineSettings from './views/MachineSettingView.vue'
import EditLayerPattern from './views/EditLayerPattern.vue'
import About from './views/About.vue'
import License from '@/components/License'
import UserManagement from '@/views/UserManagement.vue'
import DocumentViewer from '@/views/DocumentViewer.vue'
import BackupRestore from '@/views/BackupRestore.vue'
import AuditTrail from '@/views/AuditTrail.vue'
import { pageNames } from '@/pageUtils'

let pathPrefix = ''

export function getPathPrefix () {
  return pathPrefix
}

export function setPathPrefix (newPathPrefix) {
  pathPrefix = newPathPrefix
}

class Page {
  constructor (name, component, path, props, meta) {
    this.name = name
    this.component = component
    this.path = path
    this.props = props
    this.meta = meta
  }

  get routeName () {
    return pathPrefix === '' ? this.name : pathPrefix + '-' + this.name
  }

  get routeLink () {
    return { name: this.routeName }
  }
}

export const Pages = {
  HOME: new Page(pageNames.HOME, Home, '/', false, { hasUserAccess: true }),
  CREATEPALLETPATTERN: new Page(pageNames.CREATEPALLETPATTERN, CreatePalletPattern, '/create-pallet-pattern', false, { hasUserAccess: false }),
  VIEWPALLETPATTERNS: new Page(pageNames.VIEWPALLETPATTERNS, ViewPalletPatterns, '/view-pallet-patterns', false, { hasUserAccess: true }),
  DETAILS: new Page(pageNames.DETAILS, Details, '/view-details/:id', true, { hasUserAccess: true }),
  EDITPALLETPATTERN: new Page(pageNames.EDITPALLETPATTERN, EditPalletPattern, '/edit-pallet-pattern/:id', true, { hasUserAccess: false }),
  SETTINGS: new Page(pageNames.SETTINGS, Settings, '/settings', false, { hasUserAccess: true }),
  MACHINESETTINGS: new Page(pageNames.MACHINESETTINGS, MachineSettings, '/machine-settings', false, { hasUserAccess: false }),
  EDITLAYERPATTERN: new Page(pageNames.EDITLAYERPATTERN, EditLayerPattern, '/edit-layer-pattern', false, { hasUserAccess: false }),
  LICENSE: new Page(pageNames.LICENSE, License, '/license', true, { hasUserAccess: false }),
  ABOUT: new Page(pageNames.ABOUT, About, '/about', false, { hasUserAccess: true }),
  USERMANAGEMENT: new Page(pageNames.USERMANAGEMENT, UserManagement, '/user-management', false, { hasUserAccess: false }),
  DOCUMENTVIEWER: new Page(pageNames.DOCUMENTVIEWER, DocumentViewer, '/documentation', false, { hasUserAccess: true }),
  BACKUPRESTORE: new Page(pageNames.BACKUPRESTORE, BackupRestore, '/backup-restore', false, { hasUserAccess: true }),
  AUDITTRAIL: new Page(pageNames.AUDITTRAIL, AuditTrail, '/audit-trail', false, { hasUserAccess: false })
}

export function getAllRoutes () {
  const result = []
  Object.values(Pages).forEach(page => {
    result.push({
      path: pathPrefix + page.path,
      name: page.routeName,
      component: page.component,
      props: page.props,
      meta: page.meta
    })
  })
  return result
}
